import Vue from 'vue';
import { gsap } from 'gsap';
import lottie from 'lottie-web';

import ButtonAnimationLottie from '../animation/aef-live-button.json';

Vue.component('menu-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            // activeHover: null,
            // activeThumbnail: null,
            // primaryColor: '#333333',
            // hoverColor: '#bb1731',
            // isAnimating: false,
            // activeSection: null,
            // isInited: false,
            // resetHoverTimeOut: null,
            isAnimating: false,
            menuHolderBG: null,
            menuHolderShape: null,
            menuItems: null,
            menuButton: null,
            menuButtonActive: null,
            menuHamburgerHolder: null,
            menuHamburger: null,
            buttonAnimation: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.buildButton();

        EventBus.$on('navigation-toggle', (showNavigation) => {
            if (showNavigation) {
                this.closeMenu();
                return;
            }

            this.openMenu();
        });

        this.menuHolderBG = this.$el.querySelector('.menu-holder--bg');
        this.menuHolderShape = this.$el.querySelector('.menu-holder--shape');
        this.menuBottomBorderHolder = this.$el.querySelector('.menu__bottom__border-holder');
        this.menuBottomBorder = this.$el.querySelector('.menu__bottom__border');
        this.menuBottomItems = this.$el.querySelectorAll('.menu__bottom__item');
        this.menuBottomIndicator = this.$el.querySelector('.menu__bottom__vacancy-indicator');
        this.menuItems = this.$el.querySelectorAll('.menu__item');
        this.searchHolder = document.querySelector('.header__block--search');
        this.menuButton = document.querySelector('.header__block--hamburger');
        this.headerBlockActiveHolder = document.querySelector('.header__block--active-holder');
        this.menuButtonActive = document.querySelector('.header__block--active');
        this.menuHamburgerHolder = document.querySelector('.hamburger-holder');
        this.menuHamburger = {
            holder: this.menuButton.querySelector('.hamburger-holder'),
            start: this.menuButton.querySelector('.hamburger-start'),
            inner: this.menuButton.querySelector('.hamburger-inner'),
            end: this.menuButton.querySelector('.hamburger-end'),
        };
        this.button = document.querySelector('.menu__live-button-link');
        this.buttonText = document.querySelector('.menu__live-button-text');
        this.linkedin = document.querySelector('.menu__social-linkedin');
        this.newsletter = document.querySelector('.menu__newsletter-block');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        buildButton() {
            const buttonHolder = document.querySelector('.menu__live-button-lottie');

            if (buttonHolder) {
                this.buttonAnimation = lottie.loadAnimation({
                    container: buttonHolder,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    animationData: ButtonAnimationLottie,
                    rendererSettings: {
                        progressiveLoad: false,
                    },
                });
            }
        },

        openMenu() {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            const TlMenuButtonIn = gsap.timeline();
            TlMenuButtonIn.pause();
            TlMenuButtonIn
                .set(this.menuButton, {
                    x: 80,
                    delay: 0.1,
                })
                .set(this.menuButton, {
                    zIndex: 7,
                })
                .set(this.menuHamburger.holder, {
                    x: -80,
                })
                .to(this.menuHamburger.start, 0.4, {
                    x: 0,
                    y: 10,
                    ease: 'power3.out',
                })
                .to(this.menuHamburger.end, 0.4, {
                    x: 0,
                    y: -10,
                    ease: 'power3.out',
                    onComplete: () => {
                        this.isAnimating = false;
                    },
                }, '<0.05');

            const windowWidth = window.innerWidth;
            const tl = gsap.timeline();

            tl
                .fromTo(this.menuHolderBG, {
                    x: windowWidth,
                    rotate: 13,
                }, {
                    onStart: () => {
                        EventBus.$emit('navigation-toggle-state', true);
                    },
                    duration: 1.5,
                    x: 0,
                    rotate: 0,
                    ease: 'power4.out',
                })
                .fromTo(this.menuHolderShape, {
                    x: windowWidth / 2,
                    rotate: 13,
                }, {
                    duration: 1.5,
                    x: 0,
                    rotate: 9,
                    ease: 'power4.out',
                }, '<')
                .fromTo(this.menuBottomBorderHolder, {
                    x: 100,
                }, {
                    duration: 1.25,
                    x: 0,
                    ease: 'Power4.out',
                }, '<')
                .fromTo(this.menuBottomBorder, {
                    x: windowWidth,
                }, {
                    duration: 1.5,
                    x: 0,
                    ease: 'power2.out',
                }, '<')
                .fromTo(this.menuBottomItems, {
                    y: 25,
                    alpha: 0,
                }, {
                    duration: 1,
                    y: 0,
                    alpha: 1,
                    stagger: -0.1,
                    ease: 'power3.out',
                }, '<')
                .to(this.menuBottomIndicator, {
                    duration: 1,
                    ease: 'back.out(1.5)',
                    scale: 1,
                }, '<')
                .to([this.menuHamburger.start, this.menuHamburger.inner, this.menuHamburger.end], {
                    duration: 0.8,
                    x: 35,
                    stagger: 0.1,
                    ease: 'power3.out',
                    onComplete: () => {
                        gsap.set(this.menuHamburger.start, {
                            x: 26,
                            y: 52,
                            rotate: 45,
                            backgroundColor: '#2f5766',
                        });

                        gsap.set(this.menuHamburger.end, {
                            x: 26,
                            y: -52,
                            rotate: -45,
                            backgroundColor: '#2f5766',
                        });

                        gsap.to(this.headerBlockActiveHolder, 0.4, {
                            x: 80,
                            ease: 'power2.out',
                        });
                    },
                }, '<')
                .to(this.searchHolder, {
                    duration: 1,
                    x: 160,
                    ease: 'power1.out',
                    onComplete: () => {
                        if (this.buttonAnimation) {
                            gsap.fromTo(this.button, {
                                alpha: 0,
                            }, {
                                duration: 0,
                                alpha: 1,
                                onComplete: () => {
                                    if (this.buttonAnimation) {
                                        this.buttonAnimation.setDirection(1);
                                        this.buttonAnimation.goToAndPlay(0);
                                        gsap.to(this.buttonText, { alpha: 1, duration: 0.5, delay: 0.5 });
                                    }
                                },
                            });
                        }
                    },
                }, '<')
                .fromTo(this.menuItems, {
                    y: 50,
                    alpha: 0,
                }, {
                    duration: 1,
                    y: 0,
                    alpha: 1,
                    ease: 'power3.out',
                    stagger: 0.1,
                }, '<0.5')
                .to(this.menuButtonActive, {
                    duration: 0.4,
                    x: 0,
                    ease: 'power2.out',
                    onComplete: () => {
                        TlMenuButtonIn.play();
                    },
                }, '<0.5')
                .to(this.newsletter, {
                    duration: 0.4,
                    x: 0,
                    ease: 'power2.out',
                }, '<0.5')
                .to(this.linkedin, {
                    duration: 0.4,
                    alpha: 1,
                    ease: 'power2.out',
                }, '<0.5');
        },

        closeMenu() {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            const windowWidth = window.innerWidth;
            const tl = gsap.timeline();

            tl
                .to(this.menuItems, {
                    duration: 1,
                    alpha: 0,
                    stagger: 0.1,

                })
                .to(this.menuHamburger.start, {
                    duration: 0.4,
                    x: -30,
                    y: -22,
                    ease: 'power3.out',
                    onComplete: () => {
                        if (this.buttonAnimation) {
                            gsap.to(this.button, {
                                alpha: 0,
                                duration: 0.3,
                                onComplete: () => {
                                    this.buttonAnimation.goToAndStop(0);
                                    gsap.set(this.buttonText, { alpha: 0 });
                                },
                            });
                        }
                    },
                }, '<')
                .to(this.menuHamburger.end, {
                    duration: 0.4,
                    x: -30,
                    y: 22,
                    ease: 'power3.out',
                    onComplete: () => {
                        gsap.set(this.menuHamburger.start, {
                            x: 35,
                            y: 0,
                            rotate: 0,
                            backgroundColor: '#fff',
                        });

                        gsap.set(this.menuHamburger.end, {
                            x: 35,
                            y: 0,
                            rotate: 0,
                            backgroundColor: '#fff',
                        });
                    },
                }, '<0.05')
                .to(this.menuButtonActive, {
                    duration: 0.4,
                    x: 0,
                    ease: 'power2.out',
                }, '<')

                .to(this.newsletter, {
                    duration: 0.4,
                    x: '100%',
                    ease: 'power3.out',
                }, '<0.1')
                .to(this.menuButton, {
                    duration: 0.4,
                    x: 0,
                    ease: 'power3.out',
                }, '<0.1')
                .to([this.menuHamburger.start, this.menuHamburger.inner, this.menuHamburger.end], {
                    onStart: () => {
                        gsap.set(this.menuHamburger.holder, {
                            x: 0,
                        });
                    },
                    duration: 0.8,
                    x: 0,
                    stagger: 0.1,
                    ease: 'power3.out',
                }, '<0.4')
                .to(this.menuHolderBG, {
                    duration: 1.5,
                    x: windowWidth + 150,
                    rotate: 13,
                    ease: 'power4.in',
                }, '-=1.25')
                .to(this.menuHolderShape, {
                    duration: 1.5,
                    x: windowWidth / 2,
                    rotate: 13,
                    ease: 'power4.in',
                }, '<')
                .fromTo(this.menuBottomBorderHolder, {
                    x: 0,
                }, {
                    duration: 1.25,
                    x: 100,
                    ease: 'Power4.out',
                }, '<0.5')
                .to(this.menuBottomBorder, {
                    duration: 1.5,
                    x: windowWidth,
                }, '<')
                .to(this.menuBottomItems, {
                    duration: 1,
                    y: 25,
                    alpha: 0,
                }, '<')
                .to(this.menuBottomIndicator, {
                    duration: 1,
                    ease: 'back.out(1.5)',
                    scale: 0,
                }, '<')
                .to(this.searchHolder, {
                    duration: 1,
                    x: 0,
                    ease: 'power1.out',
                }, '<')
                .to(this.linkedin, {
                    duration: 1,
                    alpha: 0,
                    ease: 'power2.out',
                }, '<')
                .set(this.headerBlockActiveHolder, {
                    x: 160,
                })
                .set(this.menuButton, {
                    zIndex: 2,
                    onComplete: () => {
                        EventBus.$emit('navigation-toggle-state', false);
                        this.isAnimating = false;
                    },
                });
        },
    },
});
